var router = require('./router');

module.exports = function(handlers) {
	var _t = this;

	this.set = function(path) {
		if (this.path !== path) {
			this.path = path;
			on(this, 'set').fire();
		}
	};

	this.toString = function() {
		return this.path ? this.path : '';
	};

	this.open = function(path, force) {
		if (path == this.path && !force) {
			return;
		}

		this.path = path;
		for (var i = 0; i < this.handlers.length; i += 2) {
			var pattern = this.handlers[i];
			var handler = this.handlers[i + 1];
			var matches = this.path.match(pattern);
			if (matches) {
				matches.shift();
				handler.apply(this.handlers, matches);
				break;
			}
		}

		on(this, 'change').fire(this.path);
		on(this, 'set').fire();
	};

	this.reload = function() {
		this.open(this.path, true);
	};

	this.handlers = handlers || [];

	router.register(this);

};
